import { Link as MuiLink } from '@mui/material';
import type { LinkProps as MuiLinkProps } from '@mui/material/Link';
import type { ElementType, ReactElement } from 'react';

export type LinkProps<C extends ElementType = 'a'> = MuiLinkProps<C> & {
  to?: string;
};

export const Link = <C extends ElementType = 'a'>({
  underline = 'hover',
  ...props
}: LinkProps<C>): ReactElement => <MuiLink underline={underline} {...props} />;
